export const evolveRouteNames = {
   ROCKS: 'rocks',
   ROCK_DETAILS: 'details',
   GOALS: 'goals',
   MILESTONES: 'milestones',
   PLANNING_PERIODS: 'planning-periods',
   ISSUES: 'actions',
   LIST: 'list',
};
